import React, { useContext } from 'react';
import { IModifiersContext, ModifiersContext } from '../../../modifiersState/modifiersContext';
import { Checkbox } from 'antd';
import Text from 'components/Text/Text';

export const IsRestrictedCheckbox: React.FC = () => {
	const { toggleIsRestricted, isRestricted, IDSelectedRestaurant } = useContext<IModifiersContext>(ModifiersContext);

	return (
		<Checkbox
			checked={isRestricted}
			onChange={toggleIsRestricted}
			disabled={!IDSelectedRestaurant}
			data-test="IsRestrictedCheckbox">
			<Text translationNameSpace="listing" translationKey="modifierIsRestrictedLabel" asFragment={true} />
		</Checkbox>
	);
};
